"use client"
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useBrowser } from '@/hooks/useBrowser';
import { MobileContentGate } from './mobile-content-gate';

const DefaultMobileSide = dynamic(
  () => import('./MobileSide').then((mod) => mod.MobileSide),
  {
    ssr: false,
    loading: () => null,
  },
);

interface MobileDetectProps extends React.PropsWithChildren {
  allowedMobileContentPaths?: readonly string[];
  MobileSideComponent?: React.ComponentType<any>
}
export const MobileDetect = ({
  allowedMobileContentPaths = [],
  children,
  MobileSideComponent = DefaultMobileSide,
}: MobileDetectProps) => {
  const browser = useBrowser();
  const pathname = usePathname();

  if (!browser) {
    return children ?? null;
  }
  return (
    <MobileContentGate
      allowedPaths={allowedMobileContentPaths}
      isMobile={browser.parsePlatform().type === 'mobile'}
      MobileSideComponent={MobileSideComponent}
      pathname={pathname}
    >
      {children}
    </MobileContentGate>
  );
};
